import { Tag } from 'antd';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { ProjectIssueStatus } from '../../../../model/types';

/**
 * This component represents a project issue status component.
 * @param props - the props
 */
export const ProjectIssueStatusComponent: React.FC<Props> = (props) => {
    const { status } = props;

    switch (status) {
        case 'draft':
            return (
                <Tag color="#819099">
                    <FormattedMessage id={`projectIssue.status.${status}`} />
                </Tag>
            );
        case 'open':
            return (
                <Tag color="#ffa600">
                    <FormattedMessage id={`projectIssue.status.${status}`} />
                </Tag>
            );
        case 'answered':
        case 'work_completed':
            return (
                <Tag color="#087cd9">
                    <FormattedMessage id={`projectIssue.status.${status}`} />
                </Tag>
            );
        case 'ready_to_inspect':
            return (
                <Tag color="#7a77d9">
                    <FormattedMessage id={`projectIssue.status.${status}`} />
                </Tag>
            );
        case 'not_approved':
        case 'in_dispute':
            return (
                <Tag color="#ff495c">
                    <FormattedMessage id={`projectIssue.status.${status}`} />
                </Tag>
            );
        case 'closed':
        case 'void':
            return (
                <Tag color="#bcc9d1">
                    <FormattedMessage id={`projectIssue.status.${status}`} />
                </Tag>
            );
        default:
            return <></>;
    }
};
export default ProjectIssueStatusComponent;

interface Props {
    status?: ProjectIssueStatus;
}
